import React from "react";
import Enzyme,{ shallow, mount, render } from 'enzyme';
import Adapter from 'enzyme-adapter-react-16';
import sinon from 'sinon';
import renderer from 'react-test-renderer';
import ContactForm from '../components/ContactForm';

Enzyme.configure({ adapter: new Adapter() });

const meta = {
  type: 'school',
  test: '1'
};

const willMount = sinon.spy();
const didMount = sinon.spy();

describe("ContactForm", () => {
  test('Field Check', () => {
/*
    const tree = renderer.create(
      <ContactForm meta={meta} />
    ).toJSON();
    */
    const onButtonClick = sinon.spy();

    const wrapper = shallow(
      <ContactForm meta={meta} />
    );
//    const instance = wrapper.instance();
//    const fakeOnClickLink = jest.fn(); // モックを作成
//    instance.onClickLink = fakeOnClickLink;

//    const fakeEventObject = { target: { value: "sample@example.com" } };
    // simulateの2番目以降がハンドラの引数に渡されます
//    wrapper.find("input").simulate("change", fakeEventObject);
//    const oEmail = wrapper.find('#email');
//    console.info(oEmail);
//    print(oEmail);

//    wrapper.find('button[type=submit]').simulate('click');
    //print(wrapper.props());
    expect(wrapper.props().meta.test).toBe('1')
    expect(wrapper.props().form.getFieldValue('enquiry')).toBe('Test Enquiry')

//    wrapper.find('#submit').simulate('click');
//    expect(onButtonClick.calledOnce).to.equal(true);
//    expect(willMount.callCount).to.equal(1);
//    expect(didMount.callCount).to.equal(1);
    //expect(wrapper.find('#submit')).to.have.length(1);

    //wrapper.find('input[name="email"]').simulate('change', {target: {value: 'ken@xxx.com'}});
//    oEmail.simulate('change', {target: {value: 'test@example.com'}}); // inputに値を入れる
//    wrapper.find('button[type="submit"]').simulate('click'); // inputに値を入れる
//    expect(tree).toMatchSnapshot('success');
//    expect(fakeOnClickLink).toBeCalled();

    /*
    const wrapper = shallow(<ContactForm />);
    const email = wrapper.find('#email');
    expect(email.props('value')).toBe('ken@dimio.net');
    */
    //
//    const wrapper = mount(<ContactForm />);
//    const emailField = wrapper.find('#email');
//    const passwordField = wrapper.find('#name');
//    const submit = wrapper.find('.ant-button');
  })
});



// WEBPACK FOOTER //
// ./src/pages/contact/__test__/test.js